import { render } from "./PurchasingBarDestination.vue?vue&type=template&id=d4a35ea6"
import script from "./PurchasingBarDestination.vue?vue&type=script&lang=js"
export * from "./PurchasingBarDestination.vue?vue&type=script&lang=js"

import "./PurchasingBarDestination.vue?vue&type=style&index=0&id=d4a35ea6&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__